module.exports = __webpack_public_path__ + "img/shengtai.29e62fc5.png";